import { render } from "./control-zoom.vue?vue&type=template&id=04336f4a&scoped=true"
import script from "./control-zoom.vue?vue&type=script&lang=js"
export * from "./control-zoom.vue?vue&type=script&lang=js"

import "./control-zoom.vue?vue&type=style&index=0&id=04336f4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04336f4a"]])

export default __exports__